// extracted by mini-css-extract-plugin
export var disabled = "_s2-0";